import { render } from "./isadimForm.vue?vue&type=template&id=799679ba"
import script from "./isadimForm.vue?vue&type=script&lang=js"
export * from "./isadimForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__